module.exports = __webpack_public_path__ + "static/media/U1-T2-2-5a.8a5f618a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-2-5a.svg
// module id = 561
// module chunks = 0